import * as React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { shutdownIntercom } from './util'

import { getLogoutUrl } from '../../models/Auth'
import { CONTROLPANEL_URL } from '../../models/Controlpanel'
import { USER_ROLE, USER_PROFILE_URL } from '../../models/CurrentUser'

import { getCurrentUser } from '../../stores/CurrentUser/CurrentUserReducer'
import { getMyEventplannerRequests } from '../../stores/gig-request-eventplanner/reducer'
import { getMyArtistRequests } from '../../stores/GigRequestArtist/GigRequestArtistReducer'

import { AvatarWrapper, UserWrapper } from './style'
import HeaderMenuItem from '../../ui/header-menu-list-item'
import HeaderMenuButton from '../../ui/header-menu-button'

import HeaderMenuSpacer from '../../ui/header-menu-list-item-spacer'

import getGlobals from '../../helpers/getGlobals'
import UserAvatar from '../../ui/UserAvatar'

const mapStateToProps = state => ({
  currentUser: getCurrentUser(state),
  artistGigRequest: getMyArtistRequests(state),
  eventplannerGigRequest: getMyEventplannerRequests(state),
})

const mapDispatchToProps = dispatch => ({})

const HeaderMenuItemUserDesktop = React.memo(
  ({
    currentUser,
    showEventplannerMenu,
    showControlpanelMenu,
    artistGigRequest,
    eventplannerGigRequest,
  }) => {
    return (
      <>
        <HeaderMenuSpacer />
        <HeaderMenuItem inDropdown>
          <UserWrapper>
            <AvatarWrapper>
              <UserAvatar user={currentUser} size={30} />
            </AvatarWrapper>
            <span>{currentUser.firstName ? `Logget inn som: ${currentUser.firstName}` : null}</span>
          </UserWrapper>
        </HeaderMenuItem>
        {currentUser && currentUser.role === USER_ROLE.ADMIN ? (
          <HeaderMenuItem inDropdown>
            <HeaderMenuButton inDropdown href={getGlobals().ADMIN_SERVER_HOST}>
              Administrasjon
            </HeaderMenuButton>
          </HeaderMenuItem>
        ) : null}
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton inDropdown to={USER_PROFILE_URL}>
            Rediger profil
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuSpacer />
      </>
    )
  },
)

HeaderMenuItemUserDesktop.propTypes = {
  // state props
  currentUser: PropTypes.shape({}).isRequired,
  artistGigRequest: PropTypes.arrayOf(PropTypes.shape({})),
  eventplannerGigRequest: PropTypes.arrayOf(PropTypes.shape({})),

  // normal props
  showEventplannerMenu: PropTypes.bool,
  showControlpanelMenu: PropTypes.bool,
}
HeaderMenuItemUserDesktop.defaultProps = {
  showEventplannerMenu: false,
  showControlpanelMenu: false,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(HeaderMenuItemUserDesktop)
